import axiosConfig from "../app/axiosConfig"
import { CUSTOMER_LIST, CUSTOMER_REPOSITORY_LIST } from "../constants/apis"
import { ApiResponse } from "../models/api-response.model"
import {
  CustomerListResponse,
  CustomerRepositoryListResponse,
} from "../models/customer.model"
import {
  fetchCustomersPayloadType,
  fetchCustomersRepositoryPayloadType,
} from "../slices/customerSlice"
import {
  fetchCustomersRepositoryService,
  fetchCustomersService,
} from "../utils/customerHelpers"

export const fetchCustomerService = ({
  payload,
}: fetchCustomersPayloadType) => {
  const params = fetchCustomersService({ payload })
  return axiosConfig.get<ApiResponse<CustomerListResponse>>(CUSTOMER_LIST, {
    params,
  })
}
export const fetchCustomerRepositoryService = ({
  payload,
}: fetchCustomersRepositoryPayloadType) => {
  const params = fetchCustomersRepositoryService({ payload })
  return axiosConfig.get<ApiResponse<CustomerRepositoryListResponse>>(
    CUSTOMER_REPOSITORY_LIST,
    {
      params,
    },
  )
}
